type Props = { fill?: string };

const PlusIcon = ({ fill }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <g clipPath="url(#clip0_10266_84888)">
        <path
          d="M11.75 5.75H7.25V1.25C7.25 0.8 6.95 0.5 6.5 0.5C6.05 0.5 5.75 0.8 5.75 1.25V5.75H1.25C0.8 5.75 0.5 6.05 0.5 6.5C0.5 6.95 0.8 7.25 1.25 7.25H5.75V11.75C5.75 12.2 6.05 12.5 6.5 12.5C6.95 12.5 7.25 12.2 7.25 11.75V7.25H11.75C12.2 7.25 12.5 6.95 12.5 6.5C12.5 6.05 12.2 5.75 11.75 5.75Z"
          fill={fill ?? "white"}
        />
      </g>
    </svg>
  );
};

export default PlusIcon;
